// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ie-0";
export var fileCarousel = "_ie-2";
export var removeFileButton = "_ie-1";